<app-header-one [sticky]="true"></app-header-one>
<div *ngIf="!successfullyReserved" style="margin-bottom: 70px;" class="container">
  <div class="title1  section-t-space">
    <h2 class="title-inner1">MAKE A RESERVATION</h2>
  </div>
  <div class="reservation-container">
    <div class="row">
      <div class="col-lg-6 col-md-6 col-12">
        <mat-form-field appearance="fill" [formGroup]="reservationFormGroup" required>
          <mat-label>Choose a Date</mat-label>
          <input matInput readonly [matDatepickerFilter]="myFilter" [matDatepicker]="picker" [min]="minDate" formControlName="date">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <mat-form-field *ngIf="noDateSelected || !!availableTimes && availableTimes.length > 0" appearance="fill" [formGroup]="reservationFormGroup" required (click)="checkDateIsSelected()">
          <mat-label>Choose a Time</mat-label>
          <mat-select formControlName="time" disableOptionCentering>
            <mat-option *ngFor="let time of availableTimes" [value]="time">
              {{time}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-error *ngIf="!noDateSelected && !!availableTimes && availableTimes.length == 0 && !loadingTimes">Sorry we do not have any available times for the date selected.</mat-error>
        <mat-error *ngIf="reservationFormGroup.controls.time.errors?.selectDate">
          Please select a date before choosing time</mat-error>
        <mat-form-field appearance="fill" [formGroup]="reservationFormGroup" required>
          <mat-label>Number of people</mat-label>
          <input type="number" min="0" matInput formControlName="numberOfPeople">
        </mat-form-field>
      </div>
      <div class="col-lg-6 col-md-6 col-12">
        <mat-form-field appearance="fill" [formGroup]="reservationFormGroup" required>
          <mat-label>Name</mat-label>
          <input matInput formControlName="name">
        </mat-form-field>
        <mat-form-field appearance="fill" [formGroup]="reservationFormGroup" required>
          <mat-label>Email Address</mat-label>
          <input matInput formControlName="email">
        </mat-form-field>
        <mat-form-field appearance="fill" [formGroup]="reservationFormGroup" required>
          <mat-label>Mobile Number</mat-label>
          <input type="number" matInput formControlName="mobile">
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <mat-form-field class="example-full-width" appearance="fill" [formGroup]="reservationFormGroup">
          <mat-label>Special requests</mat-label>
          <textarea rows="5" matInput placeholder="E.g. Baby seat" formControlName="comments"></textarea>
        </mat-form-field>
        <mat-error *ngIf="failedToReserve">
          Something went wrong... please try again or call to make the reservation</mat-error>
      </div>
    </div>
    <button style="float: right;" (click)="submit()" class="btn btn-solid" id="mc-submit" [disabled]="loading">Submit Reservation<span *ngIf="loading" class="spinner-border spinner-border-sm mr-1" style="margin-left: 10px"></span></button>
  </div>
</div>
<div *ngIf="successfullyReserved">
  <section class="section-b-space light-layout">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="success-text">
            <i class="fa fa-check-circle" aria-hidden="true"></i>
            <h2>Thank You</h2>
            <p>Your Reservation Has Been Confirmed</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
<app-footer-one></app-footer-one>